enum FlexOverallOnboardingStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  UNDEFINED = 'UNDEFINED',
}

export default FlexOverallOnboardingStatus;
